import React from 'react';
import { PageInfo, Pagination, Plan, User } from '../../models';
import SubscriptionsByPlanTable from './SubscriptionsByPlanTable';
import AllSubscriptionTable from './AllSubscriptionTable';

interface SubscriptionsProps {
  plans: {
    plan: Plan;
    employees: number;
  }[];
  planSelected: Partial<Plan>;
  setPlanSelected: React.Dispatch<React.SetStateAction<Partial<Plan>>>;
  employees: Pagination<Partial<User>>;
  pagination: Partial<PageInfo>;
  setPagination: React.Dispatch<React.SetStateAction<Partial<PageInfo>>>;
}

function Subscriptions({
  planSelected,
  setPlanSelected,
  plans,
  employees,
  pagination,
  setPagination,
}: SubscriptionsProps) {
  const [subscriptionsItems] = React.useState(() =>
    plans.map((plan) => ({
      ...plan.plan,
      employeesCount: plan.employees,
    }))
  );

  return (
    <div className="w-full flex flex-wrap ">
      <div className="w-full lg:w-1/3 pt-3 lg:pr-5">
        <AllSubscriptionTable
          data={subscriptionsItems}
          setPlanSelected={setPlanSelected}
        />
      </div>
      <div className="w-full lg:w-2/3 pt-3 lg:pl-5">
        <SubscriptionsByPlanTable
          planSelected={planSelected}
          plans={plans.map((plan) => ({
            ...plan.plan,
          }))}
          data={employees}
          pagination={pagination}
          setPagination={setPagination}
        />
      </div>
    </div>
  );
}

export default Subscriptions;
